import { LoadableAfterPaint } from '@confluence/loadable';

import { RendererContentStatePlaceholder } from './RendererContentState/RendererContentStatePlaceholder.tsx';

export const LazyEditorContentStateComponent = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-EditorContentStateEditorContentStateComponent" */ './EditorContentState/EditorContentStateComponent.tsx'
			)
		).EditorContentStateComponent;
	},
});

export const LazyRendererContentStateWithSpotlight = LoadableAfterPaint({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-RendererContentStateRendererContentStateComponent" */ './RendererContentState/RendererContentStateWithSpotlight.tsx'
			)
		).RendererContentStateWithSpotlight;
	},
	loading: RendererContentStatePlaceholder,
});
